import { useEffect, useRef } from "react";
import { animate } from "animejs";
import useScrollReveal from "../useScrollReveal";
import { useTranslation } from "react-i18next";

export default function ProductShowcase() {
  const [ref, visible] = useScrollReveal();
  const { t } = useTranslation();
  const frameRef = useRef(null);
  const hasAnimatedRef = useRef(false);

  // Entrance: the mockup settles in with a slight 3D tilt-to-flat reveal.
  useEffect(() => {
    if (!visible || hasAnimatedRef.current || !frameRef.current) return;
    hasAnimatedRef.current = true;
    animate(frameRef.current, {
      opacity: [0, 1],
      rotateX: [10, 0],
      translateY: [40, 0],
      duration: 900,
      ease: "outExpo",
    });
  }, [visible]);

  // Cursor-follow tilt — a small interactive touch so the product feels
  // like something you can hold and turn, not a flat screenshot.
  const handleMouseMove = (e) => {
    const el = frameRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    animate(el, {
      rotateY: px * 10,
      rotateX: -py * 10,
      duration: 400,
      ease: "outQuad",
    });
  };

  const handleMouseLeave = () => {
    const el = frameRef.current;
    if (!el) return;
    animate(el, {
      rotateX: 0,
      rotateY: 0,
      duration: 600,
      ease: "outElastic(1, .6)",
    });
  };

  return (
    <section
      id="product-showcase"
      ref={ref}
      className={`product-showcase ${visible ? "visible" : ""}`}
    >
      <h2>{t("product.title")}</h2>
      <p>{t("product.desc")}</p>

      <div className="mockup-frame-wrap">
        <div className="mockup-frame-glow" />
        <div
          className="mockup-frame"
          ref={frameRef}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <img src="/platform.png" alt="SPCS Platform" className="product-image" />
        </div>
      </div>
    </section>
  );
}
